var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hint-alert-component"},[_c('Alert',{class:[`alert-${_vm.type}`],attrs:{"show-icon":_vm.showIcon}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }